// Rising-sun brand mark from the redesign. Uses currentColor so callers set the
// hue via text-* utilities.
export default function SunMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      <path d="M3 18.5h18" />
      <path d="M6.5 18.5a5.5 5.5 0 0 1 11 0" />
      <path d="M12 6.2v2" />
      <path d="M5.6 9.3 7 10.7" />
      <path d="M18.4 9.3 17 10.7" />
      <path d="M2.8 14.4h1.6" />
      <path d="M19.6 14.4h1.6" />
    </svg>
  );
}
